// React Refresh handles hot reloading automatically
import Pleasure from './theme/pleasure.js';

require('./components/admin/styles.less');
require('./components/audit_queue/styles.less');
require('./components/auth/styles.less');
require('./components/channels/styles.less');
require('./components/common/styles.less');
require('./components/common/utils.less');
require('./components/domain_manager/styles.less');
require('./components/filters/styles.less');
require('./components/markup/charts/charts.less');
require('./components/markup/styles.less');
require('./components/menu.less');
require('./components/inspect/styles.less');
require('./components/segments/styles.less');
require('./components/vetting_tool/styles.less');
require('./components/videos/styles.less');
require('./components/reporting/styles.less');
require('./components/my_custom_data/styles.less');
require('./components/exports_manager/styles.less');
require('./components/comscore_editor/styles.less');
require('./components/tags_editor/styles.less');
require('./components/tagger/styles.less');
require('./components/notifications_manager/styles.less');
require('./components/data_tracker/styles.less');
require('./components/explore/styles.less');
require('./components/explore/exploreFeature.less');
require('./components/explore/ctv/episodes/styles.less');
require('./components/explore/ctv/shows/styles.less');
require('./components/explore/reddit/subreddits/styles.less');
require('./components/explorev2/styles.less');
require('./components/dashboard/styles.less');
require('./components/markup/selectors/styles.less');
require('./components/extension_guide/styles.less');
require('react-phone-number-input/style.css');
require('./components/analytics/styles.less');
require('./components/crisis_keywords/styles.less');
require('./components/build/styles.less');
require('./components/trends/styles.less');
require('./components/url_converter/styles.less');
require('./components/inspect_plus/styles.less');
require('./components/base/iq_series_base_ui/styles.less');
require('./components/targeting_agent/styles.less');
require('./components/feature_flag_pilot/styles.less');

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Router, Route, Switch, Redirect } from 'react-router';
import $ from 'jquery';
import _ from 'lodash';
import Favicon from 'react-favicon';
import UserManager from './core/UserManager';
import history from './history';
import RouterHelper from './core/RouterHelper';
import PubSub from 'pubsub-js';
import GlobalConst from 'utils/GlobalConst';
import Button from 'components/markup/Button';
import Error from './components/Error';
import Menu from './components/base/iq_series_base_ui/Menu';
import AnalyticsManager from './core/AnalyticsManager';
import { Modal, ModalFooter, ModalHeader } from './components/markup/Modal';
import ContactUsModal from './components/auth/ContactUsModal';
import ReactTooltip from 'react-tooltip';
import GDPRCookiesBox from './components/auth/GDPRCookiesBox.js';
import AuthDataProvider from './components/auth/AuthDataProvider';
import NumberInputModal from './components/auth/NumberInputModal';
import WhiteLabelController from './core/WhiteLabelController';
import RoutePaths from './utils/RoutePaths';
import ErrorPageComponent from './components/ErrorPage';
import ExportsManagerDataProvider from './components/exports_manager/ExportsManagerDataProvider';
import NotificationsDataProvider from './components/notifications_manager/NotificationsManagerDataProvider.js';
import ldClient, { getLaunchDarklyIdentityPromise } from './core/launchDarkly';
import { FEATURE_FLAG_KEYS } from './core/featureFlags';

const componentsCache = {};

class AsyncComponent extends PureComponent {

	static propTypes = {
		getComponent: PropTypes.func
	};

	constructor(props) {
		super(props);
		this.state = {Component: componentsCache[props.match.path]};
	}

	componentDidMount() {
		this.resolveComponent(this.props);
	}

	componentDidUpdate(prevProps){
		if (prevProps.match.path !== this.props.match.path) {
			this.setState({Component: null});
			this.resolveComponent(this.props);
		}
	}

	resolveComponent(props) {
		const path = props.match.path;
		const cached = componentsCache[path];
		if(!cached) {
			props.getComponent().then(module => {
				const component = module.default || module;
				componentsCache[path] = component;
				this.setState({Component: component});
			})
		} else {
			this.setState({Component: cached});
		}
	}

	render() {
		const { Component } = this.state;
		if (Component) {
			return <Component {...this.props}/>;
		}
		return null;
	}

}

export const AutoRedirectRoute = ({ component: Component, getComponent, checkRedirect, extraProps, ...rest }) => (
	<Route {...rest} render={props => {
		if(checkRedirect) {
			const redirectTo = checkRedirect();
			if(!_.isEmpty(redirectTo)) {
				return <Redirect to={redirectTo}/>;
			}
		}
		const resultProps = _.isEmpty(extraProps) ? props : {...props, ...extraProps};
		const key = props.match.path;
		return Component ? <Component key={key} {...resultProps}/> : <AsyncComponent key={key} {...resultProps} getComponent={getComponent}/>;
	}}/>
);

class FeatureFlagRoute extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			ldReady: false,
			enabled: false
		};
	}

	refreshFlag = () => {
		this.setState({
			ldReady: true,
			enabled: ldClient.boolVariation(this.props.flagKey, false)
		});
	};

	componentDidMount() {
		ldClient.on(`change:${this.props.flagKey}`, this.refreshFlag);
		// Use the current identity promise so this evaluates for the authenticated user.
		getLaunchDarklyIdentityPromise().then(this.refreshFlag).catch(() => {});
	}

	componentWillUnmount() {
		ldClient.off(`change:${this.props.flagKey}`, this.refreshFlag);
	}

	render() {
		const { routeConfig } = this.props;
		const rest = _.omit(this.props, ['routeConfig', 'flagKey']);
		const { ldReady, enabled } = this.state;
		if (!ldReady) return null;
		return enabled
			? <AutoRedirectRoute {...rest} {...routeConfig}/>
			: <Redirect to="/home"/>;
	}
}

class Routes extends PureComponent {

	constructor(props) {
		super(props);
		this.state = {
			modalMessage: null,
			didAutoLogin: false,
			showGDPRBox: true,
			siteAssets: null,
			loadingUserData: true,
			googleAdsUserData: {},
			dv360UserData: {},
			metaUserData: {},
			oauthRequired: true,
			showContactUs: false,
			exportsStatus: {},
			showMaintenancePage: false,
			// Notifications
			notifications: [],
			loadingNotifications: false
		};
		PubSub.subscribe(GlobalConst.SHOW_MODAL_MSG, (type, modalMessage) => {
			if(modalMessage && modalMessage.type === GlobalConst.MODAL_TYPE_CONTACT_US) {
				this.setState({ showContactUs: true }, () => $('#app-contact-us-modal').modal('show'));
				return;
			}
			this.setState({ modalMessage }, () => {
				$(`#app-modal-${modalMessage.type}`).modal('show');
			})
		});
		PubSub.subscribe('FETCH_OAUTH_DATA', () => this.fetchUserData());
		PubSub.subscribe('CLEAR_OAUTH', () => this.clearOAuthData());
		PubSub.subscribe('CLEAR_GADS_OAUTH', () => this.clearSingleOAuth('googleAdsUserData'));
		PubSub.subscribe('CLEAR_DV360_OAUTH', () => this.clearSingleOAuth('dv360UserData'));
		PubSub.subscribe('CLEAR_META_OAUTH', () => this.clearSingleOAuth('metaUserData'));
		PubSub.subscribe('TRIGGER_NOTIFICATIONS_INITIAL', () => {
			if (!this.state.initialNotifications) {
				this.setState({ initialNotifications: true });
				this.onFetchExportsStatus();
				this.exportsInterval = setInterval(() => this.onFetchExportsStatus(), 120000);
				if (UserManager.user.canAccessSeeNotifications) {
					this.fetchUserNotifications(false);
					this.notificationsInterval = setInterval(() => this.fetchUserNotifications(true), 120000);
				}
			}
		});
		PubSub.subscribe('CLEAR_TRIGGER_NOTIFICATIONS', () => {
			clearInterval(this.exportsInterval);
			clearInterval(this.notificationsInterval);
		});
		PubSub.subscribe(GlobalConst.SHOW_MAINTENANCE_PAGE, () => {
			this.setState({ showMaintenancePage: true });
		});
		$(document).on('click', '.dropdown-menu.noclose > li', e => e.stopPropagation());
		$(document).on('click', '.dropdown-menu > li > .noclose', e => e.stopPropagation());
	}

	componentDidMount() {
		Pleasure.init();
		WhiteLabelController.getLocalAssets().then(data => this.setState({ siteAssets: data }));
		AnalyticsManager.sendPageViewAnalytics();
		this.routesUserLogin();
	}

	routesUserLogin = () => {
		let magicToken = false;
		let currentQuery = RouterHelper.currentQuery();
		if (currentQuery.emailLogin) {
			magicToken = currentQuery.magicLink;
		} else if (currentQuery.referral_token) {
			UserManager.clearAuthData();
		}
		UserManager.autoLogin(magicToken)
			.catch(xhrError => {
				if (xhrError?.responseStatus === 400) {
					PubSub.publish(GlobalConst.SHOW_MODAL_MSG, {type: 3, message: xhrError.json.message});
				}
			})
			.finally(() => {
				RouterHelper.setTitle();
				this.setState({didAutoLogin: true}, () => {
					if (location.pathname === '/referral_token') return;
					if (location.pathname === '/' && UserManager.isAuthorized) return RouterHelper.goToDefaultRoute();
					else if (location.pathname !== '/' && UserManager.isAuthorized && !UserManager.user.isActive && UserManager.user.email) return RouterHelper.goToWelcomePage();
					else if (location.pathname !== '/' && location.pathname !== '/password_reset/' && location.pathname !== '/referral_token' && !UserManager.isAuthorized) return RouterHelper.goToLogin();
					else if (location.pathname !== '/' && location.pathname !== '/password_reset/' && location.pathname !== '/referral_token' && !UserManager.user.email) return RouterHelper.goToErrorPage();
				});
			});
	}

	clearSingleOAuth = userDataKey => {
		this.setState({ [userDataKey]: {} });
	}

	fetchUserData = () => {
        this.setState({ loadingUserData: true });
        return AuthDataProvider.fetchOAuthUserData()
            .then(data => {
				this.setState({ googleAdsUserData: data.gads, dv360UserData: data.dv360, metaUserData: data.meta, oauthRequired: !data.bypass_oauth });
                RouterHelper.removeFromQuery('oauth_code');
            })
            .catch(() => PubSub.publish(GlobalConst.SHOW_MODAL_MSG, {type: 3, message: {readableMessage: 'Error getting user oauth data'}}))
			.finally(() => this.setState({ loadingUserData: false }));
    }

	clearOAuthData = () => {
		this.setState({ googleAdsUserData: {}, dv360UserData: {}, metaUserData: {}, loadingUserData: false });
	}

	onFetchExportsStatus = () => {
		ExportsManagerDataProvider.getExportsNotifications()
			.then(status => this.setState({ exportsStatus: status }));
	}

	// Notifications
	fetchUserNotifications = (autoRefresh=false) => {
		if (autoRefresh) this.setState({ loadingNotifications: true });
		NotificationsDataProvider.getUserNotifications()
			.then(data => this.setState({ notifications: data, loadingNotifications: false }));
	}

	checkUserAdmin = () => {
		if (!UserManager.user.isAdminUser) {
			return RouterHelper.accessDeniedPageURL();
		}
	}

	/**
	 * Research access is always required; each extra permission is a UserManager.user getter name that must also be true.
	 * @param {...string} permissions e.g. 'canAccessExploreCtv', 'canAccessResearchDetail'
	 * @returns {string|undefined} access denied URL when a check fails, undefined when allowed
	 * @example
	 * checkResearchPermission()                           // research only
	 * checkResearchPermission('canAccessExploreCtv')      // research + CTV
	 */
	checkResearchPermission = (...permissions) => {
		const { user } = UserManager;
		if (!user.canAccessResearch || !_.every(permissions, permission => user[permission])) {
			return RouterHelper.accessDeniedPageURL();
		}
	};

	/**
	 * Picks the platform permission from the current explore URL; YouTube (/explore/channels, /explore/videos) needs research only.
	 * @returns {string|undefined} access denied URL when a check fails, undefined when allowed
	 * @example
	 * '/explore/ctv/shows'       -> checkResearchPermission('canAccessExploreCtv')
	 * '/explore/reddit/posts'    -> checkResearchPermission('canAccessExploreReddit')
	 * '/explore/channels'        -> checkResearchPermission()
	 */
	checkExploreListPermission = () => {
		const currentPath = RouterHelper.currentPath();
		const permissionByPlatform = { meta: 'canAccessExploreMeta', ctv: 'canAccessExploreCtv', reddit: 'canAccessExploreReddit' };
		const platformPermissions = _.filter(permissionByPlatform, (permission, platform) => currentPath.includes(`${RoutePaths.EXPLORE.path}/${platform}`));
		return this.checkResearchPermission(...platformPermissions);
	};

	checkBuildPermission = () => {
		if (!UserManager.user.canAccessBuild) {
			return RouterHelper.accessDeniedPageURL();
		}
	};

	checkResearchVettingToolPermission = () => {
		if (!UserManager.user.canAccessResearchVetting&&!UserManager.user.canAccessResearchVettingBasic) {
			return RouterHelper.accessDeniedPageURL();
		}
	}

	checkCTLVettingToolPermission = () => {
		if (!UserManager.user.canAccessCTLVet&&!UserManager.user.canAccessCTLVetBasic) {
			return RouterHelper.accessDeniedPageURL();
		}
	}

	checkReviewPermissions = () => {
		if (!UserManager.user.canAccessReview) {
			return RouterHelper.accessDeniedPageURL();
		}
	};

	checkBSTEPermissions = () => {
		if (!UserManager.user.canAccessBSTE) {
			return RouterHelper.accessDeniedPageURL();
		}
	}

	checkBlocklistPermissions = () => {
		if (!UserManager.user.canAccessBlocklist) {
			return RouterHelper.accessDeniedPageURL();
		}
	}

	checkCPRScriptPermissions = () => {
		if (!UserManager.user.canAccessCPRScript) {
			return RouterHelper.accessDeniedPageURL();
		}
	}

	checkUserAnalyticsPermissions = () => {
		if (!UserManager.user.canAccessUserAnalytics) {
			return RouterHelper.accessDeniedPageURL();
		}
	}

	checkUserManagerPermissions = () => {
		if (!UserManager.user.canAccessUserManager) {
			return RouterHelper.accessDeniedPageURL();
		}
	}

	checkComscoreEditorPermissions = () => {
		if (!UserManager.user.canAccessComscoreEditor) {
			return RouterHelper.accessDeniedPageURL();
		}
	}

	checkUmbrellaTopicsPermissions = () => {
		if (!UserManager.user.canAccessUmbrellaTopics) {
			return RouterHelper.accessDeniedPageURL();
		}
	}

    checkExportsManagerPermissions = () => {
        if (!UserManager.user.domainAccessToExportsManager) {
            return RouterHelper.accessDeniedPageURL();
        }
    }

	checkNotificationsManagerPermissions = () => {
		if (!UserManager.user.canAccessNotificationsManagerCreate) {
			return RouterHelper.accessDeniedPageURL();
		}
	}

	checkToolsPermissions = type => {
		if (!UserManager.user.canAccessTools) {
			return RouterHelper.accessDeniedPageURL();
		} else if (type === 'audit' && !UserManager.user.canAccessAuditQueue) {
			return RouterHelper.accessDeniedPageURL();
		} else if (type === 'custom_data' && !UserManager.user.canAccessMyCustomData) {
			return RouterHelper.accessDeniedPageURL();
		} else if (type === 'url_converter' && !UserManager.user.canAccessURLConverter) {
			return RouterHelper.accessDeniedPageURL();
		} else if (type === 'custom_tagger' && !UserManager.user.canAccessCustomTagger) {
			return RouterHelper.accessDeniedPageURL();
		}
	};

	checkDomainManagerPermissions = () => {
		if (!UserManager.user.canAccessDomainManager) {
			return RouterHelper.accessDeniedPageURL();
		}
	}

	checkDataTrackerPermissions = () => {
		if (!UserManager.user.canAccessDataTracker) {
			return RouterHelper.accessDeniedPageURL();
		}
	}

	// TODO: Temporary until Explore V2 launches as Explore
	checkExploreV2Permission = () => {
		if (!UserManager.user.canAccessExploreV2) {
			return RouterHelper.accessDeniedPageURL();
		}
	}

	checkInspectYouTubePermissions = () => {
		const { canAccessInspectYouTube } = UserManager.user;
		if (!canAccessInspectYouTube) {
			return RouterHelper.accessDeniedPageURL();
		}
	}

	checkInspectMetaPermissions = () => {
		const { canAccessInspectMeta } = UserManager.user;
		if (!canAccessInspectMeta) {
			return RouterHelper.accessDeniedPageURL();
		}
	}

	checkNewBuildPermission = () => {
		if (UserManager.user.isAdminUser) {
			return;
		} else if (!UserManager.user.canAccessAgenticBuild && UserManager.user.canAccessAlternateBuild) {
			return RouterHelper.toAdvancedBuild();
		} else if (!UserManager.user.canAccessAgenticBuild && UserManager.user.canAccessBuild) {
			return RouterHelper.toLegacyBuild();
		} else if (!UserManager.user.canAccessAgenticBuild) {
			return RouterHelper.accessDeniedPageURL();
		}
	}

	checkTrendsPermissions = () => {
		if (!UserManager.user.canAccessTrends) {
			return RouterHelper.accessDeniedPageURL();
		}
	}

	checkTargetingAgentPermissions = () => {
		if (!UserManager.user.canAccessTargetingAgent) {
			return RouterHelper.accessDeniedPageURL();
		}
	}

	checkExtensionGuidePermissions = () => {
		if (!UserManager.user.canAccessBuildGAdsExtension&&!UserManager.user.canAccessBuildDV360Extension) {
			return RouterHelper.accessDeniedPageURL();
		}
	}

	checkFeatureFlagPermissions = () => {
		if(!UserManager.user.isAdminUser) {
			return RouterHelper.accessDeniedPageURL();
		}
	}

	hideModal(callback){
		this.setState({modalMessage: null}, callback);
	}

	onGDPRCookiesAction = response => {
		AuthDataProvider.onGDPRCookiesAction(response);
		this.setState({ showGDPRBox: false });
	}

	renderModal() {
		const { modalMessage } = this.state;
		if(!modalMessage) {
			return null;
		}
		const { type, message, title, buttons, extraProps={} } = modalMessage;
		let modalTitle, modalLabel;
		let payload = message;
		switch (type) {
			case GlobalConst.MODAL_TYPE_SUCCESS:
				modalLabel = extraProps.label || '';
				modalTitle = title || 'Success';
				break;
			case GlobalConst.MODAL_TYPE_WARN:
				modalLabel = extraProps.label || '';
				modalTitle = title || 'Warning';
				break;
			case GlobalConst.MODAL_TYPE_ERROR:
				modalTitle = extraProps.label ? title || 'Error' : title || '';
				modalLabel = extraProps.label || 'Error';
				payload = <Error error={message}/>;
				break;
			default:
				modalLabel = extraProps.label || '';
				modalTitle = title || 'Info';
				break;
		}
		return (
			<Modal id={`app-modal-${type}`} className='common-app-modal' {...extraProps}>
				{(!_.isEmpty(modalTitle) || !_.isEmpty(modalLabel)) && <ModalHeader>
					{!_.isEmpty(modalLabel) && <span className='modal-label'>{modalLabel}</span>}
					{modalTitle}
					<span className='material-icons close-common-modal' data-dismiss='modal'>close</span>
				</ModalHeader>}
				{payload}
				<ModalFooter>
					{_.isEmpty(buttons) ?
						<Button className="btn-flat btn-default" data-dismiss="modal" onClick={() => this.hideModal()}>Ok</Button> :
						_.map(buttons, button =>
							<Button key={button.title} className={button.className || 'btn-flat btn-default'} data-dismiss="modal" onClick={() => this.hideModal(button.callback)}>
								{button.title}
							</Button>
						)
					}
				</ModalFooter>
			</Modal>
		);
	}

	propsToComponents = (path='') => {
		const { googleAdsUserData, dv360UserData, metaUserData, loadingUserData, oauthRequired, loadingNotifications, notifications } = this.state;
		const globalOAuthData = { googleAdsUserData, dv360UserData, metaUserData, loadingUserData, oauthRequired, fetchUserData: this.fetchUserData };
		if (_.includes(path, 'roles/permissions')) return ({ role: true, globalOAuthData, loadingNotifications, notifications });
		return ({ globalOAuthData, loadingNotifications, notifications });
	}

	render() {
		const { didAutoLogin, showGDPRBox, showContactUs, exportsStatus, showMaintenancePage } = this.state;
		const favicon = WhiteLabelController.siteAssets.favicon || require('../src/favicon.png');

		if(!didAutoLogin) {
			return null;
		}

		// Disabling code splitting in development mode as it doesn't work properly
		let Login, BrandRegister, PasswordRestore, ReferralTokenPage, ChannelDetails, VideoDetails, CtvEpisodeDetails, CtvShowDetails, RedditSubredditDetails, ComscoreEditor, CustomTagger,
			Build, VettingTool, ExploreParent, ExploreParentV2, BlocklistManager, UserPermissionsLog, ExtensionGuide,
			AdminUserPermissions, DataTracker, UserSettings, AuditQueue, UsersList, UserAnalytics, TagsEditor, DomainManager, Inspect, InspectDetails,
			AccessDeniedPage, NotFound, WelcomePage, ErrorPage, MyCustomData, ExportsManager, UmbrellaTopics,
			NotificationsManager, CPRScript, Dashboard, AdvancedBuild, AdvancedCreateList, CrisisKeywords,
			InspectPlusList, InspectPlusDemo, BuildNew, BuildLists, Trends, URLConverter, Flags,
			TargetingAgent, TargetingAgentNewCampaign, TargetingAgentCampaignDetail, TargetingAgentPersonaDetail, TargetingAgentExpansion, TargetingAgentOpportunityDetail;
			
		if (process.env.NODE_ENV === 'development') {
			Login = {component: require('./components/auth/Login').default};
			BrandRegister = {component: require('./components/auth/BrandRegister').default};
			PasswordRestore = {component: require('./components/auth/PasswordRestore').default};
			ReferralTokenPage = {component: require('./components/base/iq_series_base_ui/referral_token_page/ReferralTokenPage.js').default};

			ExploreParent = {component: require('./components/explore/ExploreParent').default};
			ExploreParentV2 = {component: require('./components/explorev2/ExploreParent').default};
			ChannelDetails = {component: require('./components/channels/ChannelDetails').default};
			VideoDetails = {component: require('./components/videos/VideoDetails').default};
			CtvEpisodeDetails = {component: require('./components/explore/ctv/episodes/details/CtvEpisodeDetails').default};
			CtvShowDetails = {component: require('./components/explore/ctv/shows/details/CtvShowDetails').default};
			RedditSubredditDetails = {component: require('./components/explore/reddit/subreddits/details/RedditSubredditDetails').default};

			Trends = {component: require('./components/trends/Trends').default};

			Build = {component: require('./components/segments/Build').default};
			VettingTool = {component: require('./components/vetting_tool/VettingTool').default};

			Inspect = {component: require('./components/inspect/Inspect.js').default}
			InspectDetails = {component: require('./components/inspect/InspectDetails.js').default}
			InspectPlusList = {component: require('./components/inspect_plus/InspectPlusList.js').default}
			InspectPlusDemo = {component: require('./components/inspect_plus/InspectPlusDemo.js').default}

			TargetingAgent = {component: require('./components/targeting_agent/TargetingAgent.js').default}
			TargetingAgentNewCampaign = {component: require('./components/targeting_agent/NewCampaign.js').default}
			TargetingAgentCampaignDetail = {component: require('./components/targeting_agent/CampaignDetail.js').default}
			TargetingAgentPersonaDetail = {component: require('./components/targeting_agent/PersonaDetail.js').default}
			TargetingAgentExpansion = {component: require('./components/targeting_agent/TargetingExpansion.js').default}
			TargetingAgentOpportunityDetail = {component: require('./components/targeting_agent/OpportunityDetail.js').default}

			UserSettings = {component: require('./components/auth/UserSettings').default};

			UsersList = {component: require('./components/admin/UsersList').default};
			UserPermissionsLog = {component: require('./components/admin/UserPermissionsLog').default};
			UserAnalytics = {component: require('./components/admin/UserAnalytics').default};
			TagsEditor = {component: require('./components/tags_editor/TagsEditor').default};
			NotificationsManager = {component: require('./components/notifications_manager/NotificationsManager').default};
			DomainManager = {component: require('./components/domain_manager/DomainManager').default};
			AdminUserPermissions = {component: require('./components/admin/AdminUserPermissions').default};
			BlocklistManager = {component: require('./components/admin/BlocklistManager').default};
			DataTracker = {component: require('./components/data_tracker/DataTracker').default};
			ComscoreEditor = {component: require('./components/comscore_editor/ComscoreEditor.js').default};
			UmbrellaTopics = {component: require('./components/admin/UmbrellaTopics.js').default};
			CPRScript = {component: require('./components/admin/CPRScript.js').default};

			AuditQueue = {component: require('./components/audit_queue/AuditQueue').default};
			MyCustomData = {component: require('./components/my_custom_data/MyCustomData').default};
			CustomTagger = {component: require('./components/tagger/CustomTagger').default};
			ExtensionGuide = {component: require('./components/extension_guide/ExtensionGuide').default};
			URLConverter = {component: require('./components/url_converter/URLConverter').default};

			AccessDeniedPage = {component: require('./components/AccessDeniedPage').default};
			NotFound = {component: require('./components/NotFound').default};
			WelcomePage = {component: require('./components/WelcomePage').default};
			ErrorPage = {component: require('./components/ErrorPage').default};
			ExportsManager = {component: require('./components/exports_manager/ExportsManager').default};

			Dashboard = {component: require('./components/dashboard/Dashboard.js').default};

			// Experimental
			AdvancedBuild = {component: require('./components/segments/AdvancedBuild.js').default};
			AdvancedCreateList = {component: require('./components/segments/AdvancedCreateList.js').default};
			CrisisKeywords = {component: require('./components/crisis_keywords/CrisisKeywords.js').default};
			BuildNew = {component: require('./components/build/Build.js').default};
			BuildLists = {component: require('./components/build/BuildLists.js').default};
			Flags = {component: require('./components/feature_flag_pilot/Flags').default};
		} else {
			Login = {getComponent: () => import('./components/auth/Login')};
			BrandRegister = {getComponent: () => import('./components/auth/BrandRegister')};
			PasswordRestore = {getComponent: () => import('./components/auth/PasswordRestore')};
			ReferralTokenPage = {getComponent: () => import('./components/base/iq_series_base_ui/referral_token_page/ReferralTokenPage.js')};

			ExploreParent = {getComponent: () => import('./components/explore/ExploreParent')};
			ExploreParentV2 = {getComponent: () => import('./components/explorev2/ExploreParent')};
			ChannelDetails = {getComponent: () => import('./components/channels/ChannelDetails')};
			VideoDetails = {getComponent: () => import('./components/videos/VideoDetails')};
			CtvEpisodeDetails = {getComponent: () => import('./components/explore/ctv/episodes/details/CtvEpisodeDetails')};
			CtvShowDetails = {getComponent: () => import('./components/explore/ctv/shows/details/CtvShowDetails')};
			RedditSubredditDetails = {getComponent: () => import('./components/explore/reddit/subreddits/details/RedditSubredditDetails')};

			Trends = {getComponent: () => import('./components/trends/Trends')};

			Build = {getComponent: () => import('./components/segments/Build')};
			VettingTool = {getComponent: () => import('./components/vetting_tool/VettingTool')};

			Inspect = {getComponent: () => import('./components/inspect/Inspect')}
			InspectDetails = {getComponent: () => import('./components/inspect/InspectDetails.js')}
			InspectPlusList = {getComponent: () => import('./components/inspect_plus/InspectPlusList.js')}
			InspectPlusDemo = {getComponent: () => import('./components/inspect_plus/InspectPlusDemo.js')}

			TargetingAgent = {getComponent: () => import('./components/targeting_agent/TargetingAgent.js')}
			TargetingAgentNewCampaign = {getComponent: () => import('./components/targeting_agent/NewCampaign.js')}
			TargetingAgentCampaignDetail = {getComponent: () => import('./components/targeting_agent/CampaignDetail.js')}
			TargetingAgentPersonaDetail = {getComponent: () => import('./components/targeting_agent/PersonaDetail.js')}
			TargetingAgentExpansion = {getComponent: () => import('./components/targeting_agent/TargetingExpansion.js')}
			TargetingAgentOpportunityDetail = {getComponent: () => import('./components/targeting_agent/OpportunityDetail.js')}

			UserSettings = {getComponent: () => import('./components/auth/UserSettings')};

			UsersList = {getComponent: () => import('./components/admin/UsersList')};
			UserPermissionsLog = {getComponent: () => import('./components/admin/UserPermissionsLog')}
			UserAnalytics = {getComponent: () => import('./components/admin/UserAnalytics')};
			TagsEditor = {getComponent: () => import('./components/tags_editor/TagsEditor')};
			NotificationsManager = {getComponent: () => import('./components/notifications_manager/NotificationsManager')};
			DomainManager = {getComponent: () => import('./components/domain_manager/DomainManager')};
			AdminUserPermissions = {getComponent: () => import('./components/admin/AdminUserPermissions')};
			BlocklistManager = {getComponent: () => import('./components/admin/BlocklistManager')};
			DataTracker = {getComponent: () => import('./components/data_tracker/DataTracker')};
			ComscoreEditor = {getComponent: () => import('./components/comscore_editor/ComscoreEditor.js')};
			UmbrellaTopics = {getComponent: () => import('./components/admin/UmbrellaTopics.js')};
			CPRScript = {getComponent: () => import('./components/admin/CPRScript.js')};

			AuditQueue = {getComponent: () => import('./components/audit_queue/AuditQueue')};
			MyCustomData = {getComponent: () => import('./components/my_custom_data/MyCustomData')};
			CustomTagger = {getComponent: () => import('./components/tagger/CustomTagger')};
			ExtensionGuide = {getComponent: () => import('./components/extension_guide/ExtensionGuide')};
			URLConverter = {getComponent: () => import('./components/url_converter/URLConverter')};
			// AdsAnalyzer = {getComponent: () => import('./components/ads_analyzer/AdsAnalyzer')};

			AccessDeniedPage = {getComponent: () => import('./components/AccessDeniedPage')};
			NotFound = {getComponent: () => import('./components/NotFound')};
			WelcomePage = {getComponent: () => import('./components/WelcomePage')};
			ErrorPage = {getComponent: () => import('./components/ErrorPage')};
			ExportsManager = {getComponent: () => import('./components/exports_manager/ExportsManager')};

			Dashboard = {getComponent: () => import('./components/dashboard/Dashboard.js')};

			// Experimental
			AdvancedBuild = {getComponent: () => import('./components/segments/AdvancedBuild.js')};
			AdvancedCreateList = {getComponent: () => import('./components/segments/AdvancedCreateList.js')};
			CrisisKeywords = {getComponent: () => import('./components/crisis_keywords/CrisisKeywords.js')};
			BuildNew = {getComponent: () => import('./components/build/Build.js')};
			BuildLists = {getComponent: () => import('./components/build/BuildLists.js')};
			Flags = {getComponent: () => import('./components/feature_flag_pilot/Flags')};
		}

		const renderSideMenuRoutes = () => {
			return <Menu exportsStatus={exportsStatus} onFetchExportsStatus={this.onFetchExportsStatus}>
				<Switch>

					<AutoRedirectRoute exact path={`${RoutePaths.EXPLOREV2.path}/channels`} extraProps={this.propsToComponents()} checkRedirect={() => this.checkExploreV2Permission()} {...ExploreParentV2}/>
					<AutoRedirectRoute exact path={`${RoutePaths.EXPLOREV2.path}/videos`} extraProps={this.propsToComponents()} checkRedirect={() => this.checkExploreV2Permission()} {...ExploreParentV2}/>
					<AutoRedirectRoute exact path={`${RoutePaths.EXPLOREV2.path}/channels/:channelID`} extraProps={this.propsToComponents()} checkRedirect={() => this.checkExploreV2Permission() || this.checkResearchPermission('canAccessResearchDetail')} {...ChannelDetails}/>
					<AutoRedirectRoute exact path={`${RoutePaths.EXPLOREV2.path}/videos/:videoID`} extraProps={this.propsToComponents()} checkRedirect={() => this.checkExploreV2Permission() || this.checkResearchPermission('canAccessResearchDetail')} {...VideoDetails}/>
					<AutoRedirectRoute exact path={`${RoutePaths.EXPLOREV2.path}/channels/vetting_tool/:vettedID`} extraProps={this.propsToComponents()} checkRedirect={() => this.checkExploreV2Permission() || this.checkResearchVettingToolPermission()} {...VettingTool}/>
					<AutoRedirectRoute exact path={`${RoutePaths.EXPLOREV2.path}/videos/vetting_tool/:vettedID`} extraProps={this.propsToComponents()} checkRedirect={() => this.checkExploreV2Permission() || this.checkResearchVettingToolPermission()} {...VettingTool}/>
					<Redirect from={RoutePaths.EXPLOREV2.path} to={`${RoutePaths.EXPLOREV2.path}/channels`}/>

					<AutoRedirectRoute exact path={`${RoutePaths.EXPLORE.path}/:exploreTab(channels|videos|meta|ctv|reddit)/:exploreSubTab(episodes|shows|subreddits|posts)?`} extraProps={this.propsToComponents()} checkRedirect={this.checkExploreListPermission} {...ExploreParent}/>
					<AutoRedirectRoute exact path={`${RoutePaths.EXPLORE.path}/ctv/episodes/detail`} extraProps={this.propsToComponents()} checkRedirect={() => this.checkResearchPermission('canAccessExploreCtv')} {...CtvEpisodeDetails}/>
					<AutoRedirectRoute exact path={`${RoutePaths.EXPLORE.path}/ctv/shows/detail`} extraProps={this.propsToComponents()} checkRedirect={() => this.checkResearchPermission('canAccessExploreCtv')} {...CtvShowDetails}/>
					<AutoRedirectRoute exact path={`${RoutePaths.EXPLORE.path}/reddit/subreddits/detail`} extraProps={this.propsToComponents()} checkRedirect={() => this.checkResearchPermission('canAccessExploreReddit')} {...RedditSubredditDetails}/>
					<AutoRedirectRoute exact path={`${RoutePaths.EXPLORE.path}/channels/:channelID`} extraProps={this.propsToComponents()} checkRedirect={() => this.checkResearchPermission('canAccessResearchDetail')} {...ChannelDetails}/>
					<AutoRedirectRoute exact path={`${RoutePaths.EXPLORE.path}/videos/:videoID`} extraProps={this.propsToComponents()} checkRedirect={() => this.checkResearchPermission('canAccessResearchDetail')} {...VideoDetails}/>
					<AutoRedirectRoute exact path={`${RoutePaths.EXPLORE.path}/channels/vetting_tool/:vettedID`} extraProps={this.propsToComponents()} checkRedirect={() => this.checkResearchVettingToolPermission()} {...VettingTool}/>
					<AutoRedirectRoute exact path={`${RoutePaths.EXPLORE.path}/videos/vetting_tool/:vettedID`} extraProps={this.propsToComponents()} checkRedirect={() => this.checkResearchVettingToolPermission()} {...VettingTool}/>
					<Redirect from={RoutePaths.EXPLORE.path} to={`${RoutePaths.EXPLORE.path}/channels`}/>

					<Redirect from="/insights/channels/vetting_tool/:vettedID" to={`${RoutePaths.EXPLORE.path}/channels/vetting_tool/:vettedID`}/>
					<Redirect from="/insights/videos/vetting_tool/:vettedID" to={`${RoutePaths.EXPLORE.path}/videos/vetting_tool/:vettedID`}/>
					<Redirect from="/insights/channels/:channelID" to={`${RoutePaths.EXPLORE.path}/channels/:channelID`}/>
					<Redirect from="/insights/videos/:videoID" to={`${RoutePaths.EXPLORE.path}/videos/:videoID`}/>
					<Redirect from="/insights/channels" to={`${RoutePaths.EXPLORE.path}/channels`}/>
					<Redirect from="/insights/videos" to={`${RoutePaths.EXPLORE.path}/videos`}/>
					<Redirect from="/insights" to={`${RoutePaths.EXPLORE.path}/channels`}/>

					<AutoRedirectRoute exact path="/build" extraProps={this.propsToComponents()} checkRedirect={() => this.checkNewBuildPermission()} {...BuildNew}/>
					<AutoRedirectRoute exact path="/build/lists" extraProps={this.propsToComponents()} checkRedirect={() => this.checkNewBuildPermission()} {...BuildLists}/>
					<AutoRedirectRoute exact path="/advanced_build" extraProps={this.propsToComponents(false)} { ...AdvancedBuild}/>
					<AutoRedirectRoute exact path="/advanced_build/create_list" extraProps={this.propsToComponents(false)} {...AdvancedCreateList}/>
					<AutoRedirectRoute exact path="/legacy_build" extraProps={this.propsToComponents()} checkRedirect={() => this.checkBuildPermission()} {...Build}/>
					<AutoRedirectRoute exact path="/legacy_build/vetting_tool/:vettedID" extraProps={this.propsToComponents()} checkRedirect={() => this.checkCTLVettingToolPermission()} {...VettingTool}/>

					<AutoRedirectRoute exact path="/trends" extraProps={this.propsToComponents()} checkRedirect={this.checkTrendsPermissions} {...Trends}/>

					<AutoRedirectRoute exact path="/inspect" extraProps={this.propsToComponents()} checkRedirect={this.checkInspectYouTubePermissions} {...Inspect}/>
					{/* Preserve legacy Meta detail bookmarks while routing all new links through Inspect+. */}
					<Redirect exact from="/inspect/meta" to="/inspect_plus"/>
					<AutoRedirectRoute exact path="/inspect/meta/:inspectID" extraProps={this.propsToComponents()} checkRedirect={this.checkInspectMetaPermissions} {...InspectDetails}/>
					<AutoRedirectRoute exact path="/inspect/youtube/:inspectID" extraProps={this.propsToComponents()} checkRedirect={this.checkInspectYouTubePermissions} {...InspectDetails}/>
					<Redirect exact from="/i_plus" to="/inspect_plus"/>
					<Redirect exact from="/i_plus/:inspectionId" to="/inspect_plus/:inspectionId"/>
					<AutoRedirectRoute exact path="/inspect_plus" extraProps={this.propsToComponents()} checkRedirect={this.checkInspectMetaPermissions} {...InspectPlusList}/>
					<AutoRedirectRoute exact path="/inspect_plus/:inspectionId" extraProps={this.propsToComponents()} checkRedirect={this.checkInspectMetaPermissions} {...InspectPlusDemo}/>

					{/* AERO-723 — Targeting Agent (starter design) */}
					<AutoRedirectRoute exact path="/targeting_agent" extraProps={this.propsToComponents()} checkRedirect={this.checkTargetingAgentPermissions} {...TargetingAgent}/>
					<AutoRedirectRoute exact path="/targeting_agent/new" extraProps={this.propsToComponents()} checkRedirect={this.checkTargetingAgentPermissions} {...TargetingAgentNewCampaign}/>
					<AutoRedirectRoute exact path="/targeting_agent/campaign/:campaignId" extraProps={this.propsToComponents()} checkRedirect={this.checkTargetingAgentPermissions} {...TargetingAgentCampaignDetail}/>
					<AutoRedirectRoute exact path="/targeting_agent/campaign/:campaignId/expansion" extraProps={this.propsToComponents()} checkRedirect={this.checkTargetingAgentPermissions} {...TargetingAgentExpansion}/>
					<AutoRedirectRoute exact path="/targeting_agent/opportunity/:opportunityId" extraProps={this.propsToComponents()} checkRedirect={this.checkTargetingAgentPermissions} {...TargetingAgentOpportunityDetail}/>
					<AutoRedirectRoute exact path="/targeting_agent/persona/:personaId" extraProps={this.propsToComponents()} checkRedirect={this.checkTargetingAgentPermissions} {...TargetingAgentPersonaDetail}/>

					<AutoRedirectRoute exact path="/custom_data" extraProps={this.propsToComponents()} checkRedirect={this.checkToolsPermissions('custom_data')} {...MyCustomData}/>
					<AutoRedirectRoute exact path="/audit_queue" extraProps={this.propsToComponents()} checkRedirect={this.checkToolsPermissions('audit')} {...AuditQueue}/>
					<AutoRedirectRoute exact path="/custom_tagger" extraProps={this.propsToComponents()} checkRedirect={this.checkToolsPermissions('custom_tagger')} {...CustomTagger}/>
					<AutoRedirectRoute exact path="/extension_guide" extraProps={this.propsToComponents()} checkRedirect={this.checkExtensionGuidePermissions} {...ExtensionGuide}/>
					<AutoRedirectRoute exact path="/url_converter" extraProps={this.propsToComponents()} checkRedirect={this.checkToolsPermissions('url_converter')} {...URLConverter}/>
					<Redirect from="/tools/custom_data" to="/custom_data"/>
					<Redirect from="/tools/audit_queue" to="/audit_queue"/>
					<Redirect from="/tools/custom_tagger" to="/custom_tagger"/>
					<Redirect from="/tools/extension_guide" to="/extension_guide"/>
					<Redirect from="/tools/url_converter" to="/url_converter"/>
					<Redirect from="/tools" to="/audit_queue"/>

					<AutoRedirectRoute exact path="/users" extraProps={this.propsToComponents()} checkRedirect={this.checkUserManagerPermissions} {...UsersList}/>
					<AutoRedirectRoute exact path="/users/permissions_log" extraProps={this.propsToComponents()} checkRedirect={this.checkUserManagerPermissions} {...UserPermissionsLog}/>
					<AutoRedirectRoute exact path="/users/permissions/:userID" extraProps={this.propsToComponents()} checkRedirect={this.checkUserManagerPermissions} {...AdminUserPermissions}/>
					<AutoRedirectRoute exact path="/roles/permissions/:userID" extraProps={this.propsToComponents('/roles/permissions/')} checkRedirect={this.checkUserManagerPermissions} {...AdminUserPermissions}/>
					<AutoRedirectRoute exact path="/roles/permissions/" extraProps={this.propsToComponents('/roles/permissions/')} checkRedirect={this.checkUserManagerPermissions} {...AdminUserPermissions}/>
					<AutoRedirectRoute exact path="/user_analytics" extraProps={this.propsToComponents()} checkRedirect={this.checkUserAnalyticsPermissions} {...UserAnalytics}/>
					<AutoRedirectRoute exact path="/keywords_editor" extraProps={this.propsToComponents()} checkRedirect={this.checkBSTEPermissions} {...TagsEditor}/>
					<AutoRedirectRoute exact path="/blocklist_manager" extraProps={this.propsToComponents()} checkRedirect={this.checkBlocklistPermissions} {...BlocklistManager}/>
					<AutoRedirectRoute exact path="/domain_manager" extraProps={this.propsToComponents()} checkRedirect={this.checkDomainManagerPermissions} {...DomainManager}/>
					<AutoRedirectRoute exact path="/data_tracker" extraProps={this.propsToComponents()} checkRedirect={this.checkDataTrackerPermissions} {...DataTracker}/>
					<AutoRedirectRoute exact path="/comscore_editor" extraProps={this.propsToComponents()} checkRedirect={this.checkComscoreEditorPermissions} {...ComscoreEditor}/>
					<AutoRedirectRoute exact path="/umbrella_topics" extraProps={this.propsToComponents()} checkRedirect={this.checkUmbrellaTopicsPermissions} {...UmbrellaTopics}/>
					<AutoRedirectRoute exact path="/notifications_manager" extraProps={this.propsToComponents()} checkRedirect={this.checkNotificationsManagerPermissions} {...NotificationsManager}/>
					<AutoRedirectRoute exact path="/cpr_script" extraProps={this.propsToComponents()} checkRedirect={this.checkCPRScriptPermissions} {...CPRScript}/>
					<Redirect from="/admin/users/permissions_log" to="/users/permissions_log"/>
					<Redirect from="/admin/users/permissions/:userID" to="/users/permissions/:userID"/>
					<Redirect from="/admin/roles/permissions/:userID" to="/roles/permissions/:userID"/>
					<Redirect from="/admin/roles/permissions/" to="/roles/permissions/"/>
					<Redirect from="/admin/users" to="/users"/>
					<Redirect from="/admin/user_analytics" to="/user_analytics"/>
					<Redirect from="/admin/keywords_editor" to="/keywords_editor"/>
					<Redirect from="/admin/blocklist_manager" to="/blocklist_manager"/>
					<Redirect from="/admin/domain_manager" to="/domain_manager"/>
					<Redirect from="/admin/data_tracker" to="/data_tracker"/>
					<Redirect from="/admin/comscore_editor" to="/comscore_editor"/>
					<Redirect from="/admin/umbrella_topics" to="/umbrella_topics"/>
					<Redirect from="/admin/notifications_manager" to="/notifications_manager"/>
					<Redirect from="/admin/cpr_script" to="/cpr_script"/>
					<Redirect from="/admin" to="/users" />

					<AutoRedirectRoute exact path="/my_profile" extraProps={this.propsToComponents()} {...UserSettings}/>

					<AutoRedirectRoute exact path="/access_denied" {...AccessDeniedPage}/>
					<AutoRedirectRoute exact path="/exports_manager" extraProps={this.propsToComponents()} checkRedirect={this.checkExportsManagerPermissions} {...ExportsManager}/>

					<Redirect from="/dashboard" to="/home" />
					<AutoRedirectRoute exact path="/home" extraProps={this.propsToComponents()} {...Dashboard}/>

					{/* ALPHA VERSION */}
					<AutoRedirectRoute exact path="/crisis_keywords" extraProps={this.propsToComponents(false)} {...CrisisKeywords}/>
					<FeatureFlagRoute exact path="/flags" flagKey={FEATURE_FLAG_KEYS.newFeatureAsdf} extraProps={this.propsToComponents(false)} routeConfig={Flags} checkRedirect={this.checkFeatureFlagPermissions} />

					{/* Redirecting to home page for all deprecated Media Buying features */}
					<Redirect from="/forecasting" to="/home"/>
					<Redirect from="/pacing_report" to="/home"/>
					<Redirect from="/streamliner" to="/home"/>
					<Redirect from="/pacing_iq" to="/home"/>
					<Redirect from="/report_plus/accounts/detail/:id" to="/home"/>
					<Redirect from="/report_plus/opportunities/detail/:id" to="/home"/>
					<Redirect from="/report_plus/accounts/scheduled_exports" to="/home"/>
					<Redirect from="/report_plus/accounts/accounts_selector" to="/home"/>
					<Redirect from="/report_plus/accounts" to="/home"/>
					<Redirect from="/report_plus/opportunities" to="/home"/>
					<Redirect from="/report_plus" to="/home"/>
					<Redirect from="/analytics-new" to="/home"/>
					<Redirect from="/dashboard-viewer/:dashboardId" to="/home"/>
					<Redirect from="/personas_manager" to="/home"/>

					<AutoRedirectRoute {...NotFound}/>
				</Switch>
				{!document.cookie.includes(`${UserManager.user.email}=phone_popup`) && !UserManager.user.phoneNumberVerified && <NumberInputModal showOnLoad={true}/>}
				{UserManager.user.hasAcceptedGDPR == null && showGDPRBox ? <GDPRCookiesBox onGDPRCookiesAction={this.onGDPRCookiesAction} /> : null}
			</Menu>;
		};

		return (
			<Router history={history}>
				<div>
					<Favicon url={favicon} />
					<Switch>
						<AutoRedirectRoute exact path="/" {...Login}/>
						<AutoRedirectRoute exact path="/login" {...Login}/>
						<AutoRedirectRoute exact path="/brand_register" {...BrandRegister}/>
						<AutoRedirectRoute exact path="/password_reset" {...PasswordRestore}/>
						<AutoRedirectRoute exact path="/referral_token" {...ReferralTokenPage}/>
						<AutoRedirectRoute exact path="/welcome" {...WelcomePage}/>
						<AutoRedirectRoute exact path="/maintenance" {...ErrorPage}/>
						<Route render={() => {
							if(UserManager.isAuthorized && UserManager.user.isActive) {
								return renderSideMenuRoutes();
							}
							return <Redirect to="/login"/>
						}}/>

					</Switch>
					{this.renderModal()}
					{showContactUs && UserManager.user.isActive && <ContactUsModal id="app-contact-us-modal"/>}
					<ReactTooltip id="default-tooltip"/>
					<ReactTooltip id="html-tooltip" html={true}/>
					{showMaintenancePage && <ErrorPageComponent />}
				</div>
			</Router>
		);
	}

}

export const RoutesClass = Routes;
export default Routes;
